import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'ca-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon]
})
export class IconComponent {
    public icon = input.required<string>();
}
